import { render, staticRenderFns } from "./StatisticSplitCurr.vue?vue&type=template&id=55f08bdc"
import script from "./StatisticSplitCurr.vue?vue&type=script&lang=js"
export * from "./StatisticSplitCurr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports